module.exports = __webpack_public_path__ + "img/sticker-0-0.89cc5ad2.svg";